import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogoMark } from './Logo';

function FullLoader() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-muted">
      <LogoMark size={56} className="animate-pulse" />
      <div className="h-1 w-32 rounded-full bg-muted overflow-hidden">
        <div className="h-full w-1/2 bg-brand animate-[loading_1s_ease-in-out_infinite]" />
      </div>
      <style>{`@keyframes loading{0%{transform:translateX(-100%)}100%{transform:translateX(200%)}}`}</style>
    </div>
  );
}

export default function ProtectedRoute({ role, children }) {
  const { session, profile, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!session) return <Navigate to="/masuk" replace />;
  if (!profile) return <Navigate to="/masuk" replace />;
  if (role && profile.role !== role) return <Navigate to={`/${profile.role}`} replace />;
  return children;
}
